import { http, createPublicClient, fallback, webSocket } from 'viem';
import { base, baseSepolia, mainnet, optimism, optimismSepolia } from 'viem/chains';
import { SupportedNetworkIds, } from '../types/index.js';
export const fallbackTransport = (transportUrls) => {
    // Use chain public RPC as latest fallback
    return fallback([...transportUrls.map((url) => http(url)), http()]);
};
export const chainsByNetwork = {
    [SupportedNetworkIds.BASE_MAINNET]: base,
    [SupportedNetworkIds.BASE_SEPOLIA]: baseSepolia,
    [SupportedNetworkIds.OPTIMISM_MAINNET]: optimism,
    [SupportedNetworkIds.OPTIMISM_SEPOLIA]: optimismSepolia,
    [SupportedNetworkIds.ETHEREUM_MAINNET]: mainnet,
};
export const createClients = (supportedChains) => {
    return Object.entries(supportedChains).reduce((acc, [chain, transportUrls]) => {
        const networkId = Number(chain);
        const viemChain = chainsByNetwork[networkId];
        if (viemChain && transportUrls) {
            acc[networkId] = createPublicClient({
                chain: viemChain,
                transport: fallbackTransport(transportUrls),
            });
        }
        return acc;
    }, {});
};
export const createEIP7412Clients = (supportedChains) => {
    return Object.entries(supportedChains).reduce((acc, [chain, transportUrls]) => {
        const networkId = Number(chain);
        const viemChain = chainsByNetwork[networkId];
        if (viemChain && transportUrls && transportUrls.length > 0) {
            acc[networkId] = createPublicClient({
                chain: viemChain,
                transport: http(transportUrls[0]),
            });
        }
        return acc;
    }, {});
};
export const createWebSocketClients = (supportedChains) => {
    return Object.entries(supportedChains).reduce((acc, [chain, transportUrls]) => {
        const networkId = Number(chain);
        const viemChain = chainsByNetwork[networkId];
        if (viemChain && transportUrls && transportUrls.length > 0) {
            acc[networkId] = createPublicClient({
                chain: viemChain,
                transport: webSocket(transportUrls[0].replace('http', 'ws')),
            });
        }
        return acc;
    }, {});
};
//# sourceMappingURL=viem.js.map